
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1729478245121",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "1545",
    "width": "16",
    "height": "16"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M512 1024C229.234 1024 0 794.766 0 512S229.234 0 512 0s512 229.234 512 512-229.234 512-512 512z m0-113.778c219.932 0 398.222-178.29 398.222-398.222S731.932 113.778 512 113.778 113.778 292.068 113.778 512 292.068 910.222 512 910.222z m0-227.555a170.667 170.667 0 1 1 0-341.334 170.667 170.667 0 0 1 0 341.334z",
        "fill": "#1296db",
        "p-id": "1546"
      }
    }
  ]
})
    }
  